import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { apiService } from './api.service';
import { Optimizer } from '../types';

class OptimizersService {
  async getAllOptimizers(status: string = STATUS_FILTER_VALUES.ALL): Promise<Optimizer[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Optimizer[]>(CR_API_ENDPOINTS.OPTIMIZERS, params);
    } catch (error) {
      throw new Error(`Failed to fetch optimizers: ${error}`);
    }
  }

  async getActiveOptimizers(): Promise<Optimizer[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: STATUS_FILTER_VALUES.ACTIVE };
      return await apiService.get<Optimizer[]>(CR_API_ENDPOINTS.OPTIMIZERS, params);
    } catch (error) {
      throw new Error(`Failed to fetch active optimizers: ${error}`);
    }
  }

  async getOptimizerById(id: string): Promise<Optimizer> {
    try {
      return await apiService.get<Optimizer>(`${CR_API_ENDPOINTS.OPTIMIZERS}/${id}`);
    } catch (error) {
      throw new Error(`Failed to fetch optimizer: ${error}`);
    }
  }

  async createOptimizer(optimizerData: {
    type: string;
  }): Promise<Optimizer> {
    try {
      return await apiService.post<Optimizer>(CR_API_ENDPOINTS.OPTIMIZERS, optimizerData);
    } catch (error) {
      throw new Error(`Failed to create optimizer: ${error}`);
    }
  }
}

export const optimizersService = new OptimizersService();